<!--
File: catalog-list.component.html
Project: catalog-cloud
-->

<p-progressBar mode="indeterminate" *ngIf="dataLoaded == false" styleClass="catalog-list-progress"></p-progressBar>

<div class="table-catalogs-container">

  <div class="cc-page-header">
    <div class="cc-page-header-title">
      <i class="pi pi-book"></i>
      <span>{{ 'CATALOG.LIST_TITLE' | translate }}</span>
    </div>
    <div class="cc-page-header-actions">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
        <input
          pInputText
          type="text"
          [(ngModel)]="filterText"
          (ngModelChange)="applyFilter($event)"
          [placeholder]="'CATALOG.SEARCH_CAT_FASC' | translate"
          class="list-search-input"
          autocomplete="off"
        />
      </p-iconField>
      <span class="cc-page-header-divider"></span>
      <p-button
        icon="pi pi-plus"
        [label]="'CATALOG.CREATE' | translate"
        severity="primary"
        size="small"
        routerLink="/catalog/new"
      />
    </div>
  </div>

  <p-table
    [value]="filteredCatalogs"
    [scrollable]="true"
    styleClass="cc-table cc-table--striped cc-table--compact"
    [sortMode]="'multiple'"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          {{ "NAME" | translate }} <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="createdBy">
          {{ "CREATED_BY" | translate }}
          <p-sortIcon field="createdBy"></p-sortIcon>
        </th>
        <th pSortableColumn="modified">
          {{ "MODIFIED" | translate }}
          <p-sortIcon field="modified"></p-sortIcon>
        </th>
        <th pSortableColumn="fascicles" class="text-center">
          {{ "NUM_FASCICLES" | translate }}
          <p-sortIcon field="fascicles"></p-sortIcon>
        </th>
        <th pSortableColumn="pages" class="text-center">
          {{ "PAGES" | translate }} <p-sortIcon field="pages"></p-sortIcon>
        </th>
        <th class="col-actions">{{ "ACTIONS" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-catalog>
      <tr>
        <td>
          <a class="catalog-title" routerLink="/catalog/{{ catalog.id }}/fascicles">{{ catalog.name }}</a>
        </td>
        <td class="text-color-secondary">{{ catalog.createdBy?.name }} {{ catalog.createdBy?.surname }}</td>
        <td class="text-color-secondary">{{ catalog.modified | date: "dd MMM yyyy HH:mm" }}</td>
        <td class="text-center">
          <span class="catalog-badge">{{ catalog.fascicles }}</span>
        </td>
        <td class="text-center">
          <span class="catalog-badge catalog-badge--secondary">{{ catalog.pages }}</span>
        </td>
        <td>
          <div class="catalog-action-group">
            <p-button icon="pi pi-folder-open" size="small" [text]="true" severity="secondary"
              [pTooltip]="'CATALOG.GO_TO_FASCICLE_LIST' | translate" tooltipPosition="top"
              (onClick)="goToFascicles(catalog.id)" />
            <p-button icon="pi pi-pencil" size="small" [text]="true" severity="secondary"
              [pTooltip]="'CATALOG.CONFIGURE' | translate" tooltipPosition="top"
              (onClick)="configureCatalog(catalog.id)" />
            <p-button icon="pi pi-sync" size="small" [text]="true" severity="secondary"
              [pTooltip]="'CATALOG.SYNC' | translate" tooltipPosition="top"
              (onClick)="syncCatalog(catalog.id)" />
            <p-button icon="pi pi-file-export" size="small" [text]="true" severity="secondary"
              [pTooltip]="'CATALOG.EXPORT_TO_SW' | translate" tooltipPosition="top"
              (onClick)="exportCatalog(catalog.id)" />
            <p-button icon="pi pi-download" size="small" [text]="true" severity="secondary"
              [pTooltip]="'MENU.EXPORT_CSV' | translate" tooltipPosition="top"
              (onClick)="exportCsvCatalog(catalog.id)" />
            <p-button icon="pi pi-trash" size="small" [text]="true" severity="danger"
              [pTooltip]="'CATALOG.REMOVE' | translate" tooltipPosition="top"
              (onClick)="deleteCatalog($event, catalog.id)" />
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="list-empty-state" *ngIf="dataLoaded == true && dataCatalog.length == 0">
    <i class="pi pi-book"></i>
    <p>{{ 'CATALOG.EMPTY_MSG' | translate }}</p>
    <p-button
      icon="pi pi-plus"
      [label]="'CATALOG.CREATE' | translate"
      severity="primary"
      routerLink="/catalog/new"
    />
  </div>

</div>
